export enum columnFetchItemTypes {
  FETCH_COLUMN_FETCH_ITEM_REQUEST = "FETCH_COLUMN_FETCH_ITEM_REQUEST",
  FETCH_COLUMN_FETCH_ITEM_SUCCESS = "FETCH_COLUMN_FETCH_ITEM_SUCCESS",
  FETCH_COLUMN_FETCH_ITEM_FAILURE = "FETCH_COLUMN_FETCH_ITEM_FAILURE",
}